<script setup lang="ts">
import { type InputProps } from '@varlet/ui';
import { useSlots } from 'vue';

import { type FieldErrors } from '@/shared/lib';

import { FieldInput } from './index';

const value = defineModel<string | undefined>({ default: '' });

const { label, size, focusColor, clearable, preventAutoFill, autocomplete, name, errors, rules } =
  defineProps<{
    label?: string;
    size?: InputProps['size'];
    focusColor?: InputProps['focusColor'];
    clearable?: InputProps['clearable'];
    preventAutoFill?: InputProps['preventAutoFill'];
    autocomplete?: string;
    name?: string;
    inputmode?: InputProps['inputmode'];
    errors?: FieldErrors;
    rules?: InputProps['rules'];
  }>();

const emit = defineEmits<{ (e: 'focus'): void }>();

const slots = useSlots();
</script>

<template>
  <FieldInput
    v-model="value"
    type="text"
    :placeholder="label"
    :size="size"
    :focus-color="focusColor"
    :clearable="clearable"
    :prevent-auto-fill="preventAutoFill"
    :autocomplete="autocomplete"
    :name="name"
    :inputmode="inputmode"
    :rules="rules"
    :errors="errors"
    @focus="() => emit('focus')"
  >
    <template
      v-if="slots['prepend-icon']"
      #prepend-icon
    >
      <slot name="prepend-icon" />
    </template>
    <template
      v-if="slots['append-icon']"
      #append-icon
      ><slot name="append-icon"
    /></template>
  </FieldInput>
</template>
